import React, { useEffect, useState } from 'react';
import { Bubble, Tabs } from 'tea-component';
import moment from 'moment';
import Download from '@/pages/opinion/components/FilterBoxCommon/filters/download';

import './index.scss';
import { getLocale, useIntl } from 'umi';
import { getContentDetail } from '@op/utils/languageValue';

export default function TabsExample(props: any) {
  const { reportInsightConfig = [], download } = props;
  const [tabList, setTabList] = useState<Array<any>>([]);
  const [activeId, setActiveId] = useState('');
  const [tabs, setTabs] = useState<Array<{ id: string; label: string }>>([]);
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (
      reportInsightConfig &&
      Array.isArray(reportInsightConfig) &&
      reportInsightConfig?.length > 0
    ) {
      const curTabs = props.reportInsightConfig.sort((a, b) => {
        if (moment(b.date).isAfter(moment(a.date))) {
          return 1;
        } else if (moment(b.date).isBefore(moment(a.date))) {
          return -1;
        } else return 0;
      });
      setTabList(curTabs);

      setActiveId(curTabs[0].date);

      props.handleInit?.({
        date: curTabs[0].date,
        title: curTabs[0].title,
      });
    }
  }, [props.reportInsightConfig]);

  useEffect(() => {
    const key = getLocale()?.split('-')?.[0] || 'en';

    setTabs(
      tabList.map((item) => ({
        id: item.date,
        label: getContentDetail(
          {
            origin: 'title',
            en: 'title_en',
            zh: 'title',
          },
          key,
          item,
        ),
      })),
    );
  }, [formatMessage, tabList]);

  const tabBarRender = (children: JSX.Element, tab: any) => {
    return (
      <div
        // className="tea-btn tea-btn--weak"
        onClick={() =>
          handleReportChange({
            date: tab.id,
            title: tab.label,
          })
        }
      >
        {children}
      </div>
    );
  };

  const handleReportChange = (child: { date: any; title?: any }) => {
    props.handleReportChange?.(child);
    setActiveId(child.date);
  };

  const downloadPdf = () => {
    const item = tabs.find((info: { id: any }) => info.id === activeId);

    download(item.label || activeId);
  };

  return (
    <div className="dbo-segment-wrapper">
      <Tabs
        tabs={tabs}
        activeId={activeId}
        tabBarRender={tabBarRender}
        tabBarStyle={{}}
        className={`dbo-segment-tab ${props.className}`}
        style={props.style}
      ></Tabs>
      <Bubble
        dark
        closeOnScroll
        placement="left"
        content={formatMessage({ id: 'Download this report' })}
      >
        <Download onClick={downloadPdf}></Download>
      </Bubble>
    </div>
  );
}
